import { gql } from "@apollo/client";

const EMAIL_LOG_ADDED = gql`
  subscription emailLogAdded($recipient: String!) {
    emailLogAdded(recipient: $recipient) {
      id
      createdDate
    }
  }
`;

const emailLog = { EMAIL_LOG_ADDED };

export default emailLog;
